import React, { useState } from 'react';
import { connect } from 'react-redux';
import withSizes from "react-sizes";

import { Row, Col } from 'deltoid/core/Blocks/BootstrapContainers';
import { Caption } from 'deltoid/core/Blocks/Typography';
import Form from 'deltoid/core/Form';
import FormFooter from '@components/BaseComponents/FormFooter';
import TextDivider from '@components/BaseComponents/TextDivider';
import SingleFileUploader from '@components/BaseComponents/SingleFileUploader';
import { kycActions, kycSelectors, toastActions, dialogActions, merchantSelectors } from '@store/ducks';

import { aadharShareCodeRegex } from '@utils/validations';

const Consent = ({
  aadharConsentProcessing,
  verifyAadharXML,
  showToast,
  signingAuthorityDetails,
  why,
  showTnc,
  uploadAadharXML,
  uploadAadharXMLProcessing,
  isMobile,
}) => {
  const [aadharXMLConsent, setAadharXMLConsent] = useState(false);
  const [file, setFile] = useState(null);
  const [shareCode, setShareCode] = useState(null);
  const [xmlErrors, setXmlErrors] = useState({});
  const { name } = (
    signingAuthorityDetails
    && signingAuthorityDetails[0]
  ) || { name: 'NA' };

  const handleDocAccepted = ([file]) => {
    setFile(file);
    setXmlErrors({ ...xmlErrors, xml: null });
  };

  const handleDocRejection = (fileError) => {
    const errMsg = fileError?.[0]?.errors?.[0]?.message;
    if (errMsg)
      setXmlErrors({ ...xmlErrors, xml: errMsg });
  };

  const handleRemoveFile = () => setFile(null);

  const handleSubmit = () => {
    if (aadharXMLConsent) {
      verifyAadharXML();
    } else if (file && shareCode) {
      if (aadharShareCodeRegex(shareCode)) {
        setXmlErrors({ ...xmlErrors, code: aadharShareCodeRegex(shareCode) });
        return;
      }
      let formData = new FormData();
      formData.append('aadhaar_file', file);
      formData.append('aadhaar_share_code', shareCode);
      uploadAadharXML(formData);
    } else {
      if (file || shareCode) {
        let errMsgs = {};
        if (!file) errMsgs.xml = 'Please upload a file';
        if (!shareCode) errMsgs.code = 'This field can not be empty';
        setXmlErrors(errMsgs);
      } else {
        showToast({
          variant: 'info', title: 'Info', content: 'Please provide the consent by checking the checkbox',
        })
      }
    }
  }
  return (
    <>
    <Row className='px-4'>
      <Col md={12}>
        <Caption variant='medium' className='pb-3'>Verify KYC of Signing Authority using  your Aadhar number</Caption>
        <Row>
          <Col md={6}>
            <Form.Text
              className='mb-3'
              value={name}
              readOnly
            />
          </Col>
        </Row>
        <Form.Group>
          <div className='d-flex flex-row align-items-baseline mt-2'>
            <Form.Checkbox
              id='aadharConsent'
              name='aadharConsent'
              onChange={(e) => setAadharXMLConsent(e.target.checked)}
              data-testid='aadhar-consent'
            />
            <Form.Label id='aadharConsent' className='align-self-end pl-2'>
              By proceeding I accept{' '}
              <Form.Button variant='underlined' className={`p-0 ${isMobile ? 'd-block' : ''}`} onClick={showTnc}>Aadhar Terms and Conditions</Form.Button>
            </Form.Label>
          </div>
        </Form.Group>
      </Col>
    </Row>
    <Row className='px-4'>
      <Col>
        <TextDivider text='OR' variant='small' className='mb-3'/>
      </Col>
    </Row>
    <Row className='px-4 mb-2'>
      <Col md={6}>
        <Form.Group>
          <Form.Label>Upload Aadhar</Form.Label>
          <SingleFileUploader
            allowedFileExtensions="application/zip, application/x-zip-compressed, text/xml"
            maxFileSizeInMB={6}
            onFileDropAccepted={handleDocAccepted}
            onFileDropRejected={handleDocRejection}
            handleRemoveFile={handleRemoveFile}
            placeholder='Upload Aadhar XML'
            uploaderState={xmlErrors.xml ? 'uploadError' : (file ? 'uploaded' : null)}
          />
          { xmlErrors.xml
            ? <Form.Message type='error'>{xmlErrors.xml}</Form.Message>
            : <Form.Message >You can generate your Aadhar XML from official <a href='https://resident.uidai.gov.in/offline-kyc' target='blank'>UIDAI website.</a></Form.Message>
          }
        </Form.Group>
      </Col>
      <Col md={6}>
        <Form.Group>
          <Form.Label id="shareCode">Share Code</Form.Label>
          <Form.Text
            id="shareCode"
            placeholder='Enter Share Code'
            onChange={(e) => setShareCode(e?.target?.value)}
          />
          { xmlErrors.code &&  <Form.Message type='error'>{xmlErrors.code}</Form.Message>}
        </Form.Group>
      </Col>
    </Row>
    <FormFooter
      tooltipProps={why}
      btnProps={{
        label: 'Verify Aadhar',
        type: "button",
        onClick: handleSubmit,
        disabled: aadharConsentProcessing || uploadAadharXMLProcessing,
        loading: aadharConsentProcessing || uploadAadharXMLProcessing,
      }}
    />
    </>
  )
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 460,
});

const Responsive = withSizes(mapSizesToProps)(Consent);

const mapStateToProps = (state) => ({
  aadharConsentProcessing: kycSelectors.aadharConsentProcessing(state),
  uploadAadharXMLProcessing: kycSelectors.uploadAadharXMLProcessing(state),
  signingAuthorityDetails: merchantSelectors.getSigningAuthorityDetails(state),
})

const mapDispatchToProps = dispatch => ({
  verifyAadharXML: () => dispatch(kycActions.aadharConsent()),
  uploadAadharXML: (formData) => dispatch(kycActions.uploadAadharXML(formData)),
  showToast: (toastProps) => dispatch(toastActions.show(toastProps)),
  showTnc: () => dispatch(dialogActions.open('aadhar-tnc')),
});

export default connect(mapStateToProps, mapDispatchToProps)(Responsive);
